<template>
  <transition name="file-modal-fullscreen" appear>
    <slot></slot>
  </transition>
</template>

<script>
export default {
  name: 'LLFileModalTransition'
}
</script>

<style lang="scss">
.file-modal-fullscreen-enter-active,
.file-modal-fullscreen-leave-active {
  transition-duration: 300ms;
  .LLFileModal__background {
    transition-duration: 300ms;
    transition-property: opacity;
  }
  .LLFileModal__block {
    transition-duration: 300ms;
    transition-property: opacity, transform;
    transition-timing-function: cubic-bezier(0.98, 0.18, 0, 1);
  }
}
.file-modal-fullscreen-enter,
.file-modal-fullscreen-leave-to {
  .LLFileModal__background {
    opacity: 0;
  }
  .LLFileModal__block {
    opacity: 0;
    transform: scale(0.95);
  }
}
</style>
